var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "UI / More"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_573",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    width: 25,
    height: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icons / UI / More",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0619 10.9375V1.04688C14.0619 0.46875 13.5942 0 13.0161 0H11.9839C11.4058 0 10.937 0.46875 10.937 1.04688V10.9375H1.04683C0.46873 10.9375 0 11.4062 0 11.9844V13.0167C0 13.5938 0.46873 14.0625 1.04683 14.0625H10.937V23.9542C10.937 24.5312 11.4058 25 11.9839 25H13.0161C13.5942 25 14.0619 24.5312 14.0619 23.9542V14.0625H23.9532C24.5313 14.0625 25 13.5938 25 13.0167V11.9844C25 11.4062 24.5313 10.9375 23.9532 10.9375H14.0619Z",
    fill: "#4A4A4A"
  })))));
};
export default SvgPlus;